export class Plate {
  licensePlate!: string;
}
